import React from 'react';
import { theme } from '../../theme';

// Table header with optional sort + filter affordances. Click cycles
// asc → desc → none, matching the way Swipe (and most data grids) behave.
//
// Props:
//   label      column title
//   field      sort key (string) — passed back to onSort
//   sortKey    currently sorted field
//   sortDir    'asc' | 'desc' | null
//   onSort     (field, nextDir) => void
//   filterable show a small funnel icon next to the label
//   onFilter   () => void (open filter popover — caller renders the popover)
//   align      'left' | 'right' | 'center' (default left)
export default function SortableTh({
  label, field, sortKey, sortDir, onSort,
  filterable = false, onFilter,
  align = 'left',
}) {
  const isSorted = sortKey === field;
  const dir = isSorted ? sortDir : null;

  const handleClick = () => {
    if (!onSort || !field) return;
    const next = !isSorted ? 'asc' : (sortDir === 'asc' ? 'desc' : null);
    onSort(field, next);
  };

  return (
    <th style={{
      padding: '11px 14px',
      borderBottom: `1px solid ${theme.border}`,
      color: theme.textMuted,
      textAlign: align,
      fontSize: '0.74rem',
      fontWeight: '700',
      textTransform: 'uppercase',
      letterSpacing: '0.04em',
      backgroundColor: '#fafbfc',
      whiteSpace: 'nowrap',
    }}>
      <div style={{
        display: 'inline-flex', alignItems: 'center', gap: '6px',
        cursor: field ? 'pointer' : 'default',
        userSelect: 'none',
      }} onClick={handleClick}>
        <span>{label}</span>
        {field && (
          <span style={{ display: 'inline-flex', flexDirection: 'column', lineHeight: 0.6 }}>
            <span style={{ fontSize: '8px', color: dir === 'asc' ? theme.primary : theme.textSubtle }}>▲</span>
            <span style={{ fontSize: '8px', color: dir === 'desc' ? theme.primary : theme.textSubtle }}>▼</span>
          </span>
        )}
        {filterable && (
          <button
            onClick={(e) => { e.stopPropagation(); onFilter && onFilter(); }}
            title="Filter"
            style={{
              background: 'transparent', border: 'none', cursor: 'pointer',
              padding: '2px', color: theme.textSubtle, display: 'inline-flex',
            }}
          >
            <svg width="11" height="11" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.4"><path d="M22 3H2l8 9.46V19l4 2v-8.54L22 3z"/></svg>
          </button>
        )}
      </div>
    </th>
  );
}
